import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta04Model } from './model-consultaSeguimentoPergunta04'

export const convertConsultaSeguimentoPergunta04ToInput = (
  value: ConsultaSeguimentoPergunta04Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_04_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_04_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_04_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_04_GOSTA_DE_SUBIR_EM?.ESCADAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_04_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_04_GOSTA_DE_SUBIR_EM?.CADEIRAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_04_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_04_GOSTA_DE_SUBIR_EM?.MOVEIS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_04_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_04_GOSTA_DE_SUBIR_EM?.BRINQUEDOS),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
